import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LsLoaderModule } from '@ls-custom-ui/ls-loader/ls-loader.module';
import { WidgetModule } from '@ls-custom-ui/widget/widget.module';
import { ShareModule } from '@ls-custom-ui-advanced/share/share.module';
import { ContragentModule } from '@ls-features/contragent/contragent.module';
import { PaymentModule } from '@ls-features/payment/payment.module';
import { OrderPositionModule } from '@ls-features-facade-ui/order-position/order-position.module';
import { ContactModule } from '@ls-features/contact/contact.module';
import { SvgIconButtonComponent } from '@ls-custom-ui/svg/svg-icon-button/svg-icon-button.component';

import { PublicOrderWidgetRoutingModule } from './public-order-widget-routing.module';
import { PagePublicOrderWidgetComponent } from './page-public-order-widget/page-public-order-widget.component';

@NgModule({
    declarations: [PagePublicOrderWidgetComponent],
    imports: [
        CommonModule,
        PublicOrderWidgetRoutingModule,
        ReactiveFormsModule, FormsModule,
        LsLoaderModule,
        WidgetModule,
        ContragentModule,
        PaymentModule,
        OrderPositionModule,
        ContactModule, ShareModule, SvgIconButtonComponent,
    ],
})
export class PublicOrderWidgetModule {
}
